/* eslint-disable @reatom/unit-naming-rule */
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { reatomCreatorPairsStats } from '../../creator-pairs/atoms/reatom-creator-pairs-stats'

import { DevTokensDevInfo } from './dev-tokens-dev-info'
import { DevTokensHighlights } from './dev-tokens-highlights'
import { DevTokensStatsMigrations } from './dev-tokens-stats-migrations'

import type { CreatorPairsStatsModel } from '../../creator-pairs/atoms/reatom-creator-pairs-stats'
import type { Address } from '@root/entities/address/Address'
import type { PairModel } from '@root/entities/pair'

type DevTokenStatisticsProps = {
  pair: PairModel
  creatorAddress: Address
  overviewModel?: CreatorPairsStatsModel
}

export const DevTokenStatistics: React.FC<DevTokenStatisticsProps> = ({
  pair,
  creatorAddress,
  overviewModel: initialOverviewModel,
}) => {
  const model = useMemo(
    () =>
      initialOverviewModel ??
      reatomCreatorPairsStats({ creatorAddress, network: pair.network }),
    [creatorAddress, initialOverviewModel, pair.network],
  )

  return (
    <Root>
      <DevTokensStatsMigrations model={model} />
      <DevTokensDevInfo pair={pair} />
      <DevTokensHighlights pair={pair} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-content: start;
  gap: 4px;

  padding-inline: 4px;
  padding-block: 4px;
  border-radius: 14px;
  background: var(--background-1);
`
